import { useState, useEffect } from 'react';
import { mutate } from 'swr';
import apiClient from '../../utils/axiosConfig';
import { removeLocalStorage } from '../../utils/cookieUtils';
import { useTranslation } from 'react-i18next';
import { useQuery } from '../../hook/useQuery';
export const useUser = () => {
    const { t } = useTranslation()
    const [itemsPerPage, setPerPge] = useState(50)
    const [page, setPage] = useState(1);
    const { filterUrl } = useQuery();
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [users, setUsers] = useState([]);
    const [total, setTotal] = useState([]);
    const [lastPage, setLastPage] = useState([]);

    const fetchData = async () => {
        const queryString = filterUrl() || '';
        const url = `/user?perPage=${itemsPerPage}&page=${page}&${queryString}`;
        try {
            const response = await apiClient.get(url);
            await mutate(`/user?perPage=${itemsPerPage}&page=${page}&${queryString}`);
            setData(response?.data);
            setError(null);
        } catch (err) {
            setError(err.response?.data || 'An error occurred');
            setData(null);
        }
    };

    useEffect(() => {
        if (data?.data?.users?.data) {
            setUsers([...data?.data?.users?.data]);
            setTotal(data?.data?.users?.total);
            setLastPage(data?.data?.users?.last_page);
        }
    }, [data]);

    const addUser = async (newData) => {
        try {
            const response = await apiClient.post('/user', newData);
            mutate(`/user?perPage=${itemsPerPage}&page=${page}`);
            return response.data
        } catch (error) {
            return error.response.data

        }
    };


    const updateUser = async (id, updatedData) => {
        try {
            const response = await apiClient.put(`/user/${id}`, updatedData);
            mutate(`/user?perPage=${itemsPerPage}&page=${page}`);
            mutate(`/user/${id}`);
            return response
        } catch (err) {
            return err.response.data
        }
    };

    const updateUserProfile = async (id, updatedData) => {
        try {
            const response = await apiClient.put(`/user/${id}`, updatedData);
            mutate(`/user?perPage=${itemsPerPage}&page=${page}`);
            return response
        } catch (err) {
            return err.response.data
        }
    };

    const deleteUser = async (id) => {
        try {
            const response = await apiClient.delete(`/user/${id}`);
            mutate(`/user?perPage=${itemsPerPage}&page=${page}`);
            return response.data;
        } catch (err) {
            return err.response.data;
        }
    };

    const getUserById = async (userId) => {
        const response = await apiClient.get(`/user/${userId}`);
        return response.data;
    };

    const setUserRoles = async (userId, roles) => {
        const response = await apiClient.put(`/set-user-role/${userId}`, roles);
        mutate(`/user?perPage=${itemsPerPage}&page=${page}`);
        return response.data;
    };

    const logout = async () => {
        try {
            const response = await apiClient.post(`/logout`);
            removeLocalStorage('authToken');
            removeLocalStorage('authUser');
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || "Logout failed");
        }
    };

    const validatedToken = async (token) => {
        const response = await apiClient.post(`/validate-token/${token}`);
        return response;
    };
    const updateStatus = async (id) => {
        try {
            const response = await apiClient.put(`/user/${id}/status`);
            mutate(`/user?perPage=${itemsPerPage}&page=${page}`);
            return response.data;
        } catch (err) {
            return err.response.data;
        }
    };
    const getUserObject = (user) => {
        user = {
            name: user.name,
            surname: user.surname,
            email: user.email,
            role: user.roles.map(role => role.name).join(', '),
            status: user.status == 0 ? t('properties.inactive') : t('properties.active')
        }
        return user;
    }

    const getAll = async () => {
        try {
            const response = await apiClient.get(`/user`);
            mutate(`/user`);
            return Array.isArray(response?.data?.data?.users) ? response?.data?.data?.users : [];
        } catch (err) {
            return err.response.data;
        }
    }
    return {
        users,
        currentPage: page,
        addUser,
        isLoading: !error && !data,
        total,
        isError: error,
        lastPage,
        setPage,
        itemsPerPage,
        updateUser,
        validatedToken,
        updateStatus,
        fetchData,
        logout,
        setUserRoles,
        getUserById,
        deleteUser,
        updateUserProfile,
        updateUser,
        getUserObject,
        setPerPge,
        getAll
    }
}